var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "favorite",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_16",
    "data-name": "Rect\\xE1ngulo 16",
    width: 18.359,
    height: 16.598,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_31",
    "data-name": "Rect\\xE1ngulo 31",
    width: 24,
    height: 24,
    fill: "#1c1c1c",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31",
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M18.293,4.756A5.638,5.638,0,0,0,15.241.6a5.472,5.472,0,0,0-6.061.748A5.468,5.468,0,0,0,3.118.6,5.593,5.593,0,0,0,1.633,9.562l6.675,6.676a1.232,1.232,0,0,0,1.743,0l6.676-6.676a5.6,5.6,0,0,0,1.566-4.806M14.554,1.93a4.157,4.157,0,0,1,2.257,3.058A4.1,4.1,0,0,1,15.666,8.5L9.192,15l-6.5-6.5A4.1,4.1,0,0,1,1.548,4.988,4.159,4.159,0,0,1,3.805,1.93a3.789,3.789,0,0,1,1.73-.411A4.233,4.233,0,0,1,8.483,2.738a.994.994,0,0,0,1.393,0,4.09,4.09,0,0,1,4.678-.808",
    fill: "#1c1c1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.fd6170a08dba7199bec11ee54f197406.svg";
export { ForwardRef as ReactComponent };